import { createContext, useContext, useState, useCallback } from "react";
import { useAuth } from "./AuthContext";
import { apiClient } from "../apiClient";

interface User {
  id: number;
  username: string;
  email: string;
  role: string;
  created_at: string;
  is_active: boolean;
  password?: string;
  profile_picture_url?: string | null;
}

interface UsersContextType {
  users: User[];
  fetchUsers: () => void;
  deleteUser: (id: number) => Promise<void>;
}

const UsersContext = createContext<UsersContextType | undefined>(undefined);


export const UsersProvider = ({ children }: { children: React.ReactNode }) => {
  const { isAuthenticated } = useAuth();
  const [users, setUsers] = useState<User[]>([]);

  const fetchUsers = useCallback(async () => {
    if (!isAuthenticated) return;
    try {
      const res = await apiClient.get("users/");
      setUsers(res.data.users);
    } catch (err) {
      console.error(err);
    }
  }, [isAuthenticated]);

  const deleteUser = async (id: number) => {
    if (!isAuthenticated) return;
    await apiClient.delete(`deleteUser/${id}`);
    fetchUsers();
  };

  return (
    <UsersContext.Provider value={{ users, fetchUsers, deleteUser }}>
      {children}
    </UsersContext.Provider>
  );
};

export const useUsers = () => {
  const context = useContext(UsersContext);
  if (!context) throw new Error("useUsers deve essere usato dentro UsersProvider");
  return context;
};
